import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Event, EventFilters } from '../models';
import { PagedOverview } from 'src/app/standalone/models/paged-overview.model';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject('BASE_URL')
    private BASE_URL: string
  ) {}

  getEvents() {
    return this.http.get<Event[]>(`${this.BASE_URL}api/events`);
  }

  getFeaturedEvents() {
    return this.http.get<Event[]>(`${this.BASE_URL}api/events/featured`);
  }

  getRelatedEvents(eventId: number) {
    return this.http.get<Event[]>(`${this.BASE_URL}api/events/related/${eventId}`);
  }

  getEventsOverview(skip: number = 0, take: number = 0, filters?: EventFilters) {
    // Map filters to query params
    let params = '';
    if (filters) {
      Object.keys(filters).forEach(k => {
        const key = k as unknown as keyof EventFilters;
        if (filters[key]) {
          if (Array.isArray(filters[key])) {
            (filters[key] as number[]).forEach((value: string | number) => {
              params += `&${key}=${value}`;
            });
          } else {
            params += `&${key}=${filters[key]}`;
          }
        }
      });
    }

    return this.http.get<PagedOverview<Event>>(`${this.BASE_URL}api/events/overview?take=${take}&skip=${skip}${params}`);
  }

  getEventById(id: number, eventDate?: string) {
    return this.http.get<Event>(`${this.BASE_URL}api/events/${id}?eventDate=${eventDate || ''}`);
  }

  getFilterFields() {
    return this.http.get<{ [key: string]: { id: number; name: string }[] }>(`${this.BASE_URL}api/events/filter-fields`);
  }
}
